import { useApi } from '@/api';
import { Page } from '@/components';
import {
  Flex,
  Heading,
  CryptoIcon,
  Card,
  EmptyBox,
  BlankNotepadIcon,
  KpiCard
} from '@blockanalitica/ui';
import { useParams } from 'react-router';
import CollateralAssetSankeyChart from './CollateralAssetSankeyChart';
import CollateralAssetHistoricBarChart from './CollateralAssetHistoricBarChart';

type Collateral = {
  date: string;
  underlying_address: string;
  underlying_symbol: string;
  underlying_name: string | null;
  total_debt: string | null;
  total_debt_change: string | null;
  total_debt_change_percentage: string | null;
  emode_category: string | null;
};

export default function CollateralPage() {
  const { marketAddress, network } = useParams() as {
    marketAddress: string;
    network: string;
  };

  const [data, error] = useApi<Collateral>({
    url: `/markets/${marketAddress}/`
  });

  if (error) {
    throw error;
  }

  if (!data || Object.keys(data).length === 0) {
    return (
      <EmptyBox
        icon={<BlankNotepadIcon />}
        message={`This collateral asset is not backing any debt`}
      />
    );
  }
  const title = (
    <Flex gap="xs">
      <CryptoIcon
        name={data.underlying_symbol}
        address={marketAddress}
        network={network}
        size="5"
      />
      <Heading size="0">Collateral Backing Debt</Heading>
    </Flex>
  );

  return (
    <Page title={title}>
      <KpiCard
        title={`Total debt backed by ${data.underlying_symbol} `}
        data={data}
        field="total_debt"
        options={{
          trend: true,
          variants: { valuePercentageValue: 'dynamic' },
          currency: 'USD'
        }}
      />
      <Card>
        <CollateralAssetSankeyChart marketAddress={marketAddress} />
      </Card>

      <Card>
        <CollateralAssetHistoricBarChart marketAddress={marketAddress} />
      </Card>
    </Page>
  );
}
